(function () {
  function parseDelaySeconds(raw) {
    var n = parseInt(raw, 10);
    if (!Number.isFinite(n) || n < 1) return 6000;
    return n * 1000;
  }

  function destroyRoot(root) {
    if (!root) return;
    if (root._fitMonthSlideshowSwiper && typeof root._fitMonthSlideshowSwiper.destroy === 'function') {
      try {
        root._fitMonthSlideshowSwiper.destroy(true, true);
      } catch (e) {
        /* ignore */
      }
      root._fitMonthSlideshowSwiper = null;
    }
  }

  function initRoot(root) {
    if (!root) return;

    destroyRoot(root);

    var swiperEl = root.querySelector('.fit-month-slideshow__swiper');
    var paginationEl = root.querySelector('.fit-month-slideshow__pagination');
    var prevEl = root.querySelector('.fit-month-slideshow__nav-btn--prev');
    var nextEl = root.querySelector('.fit-month-slideshow__nav-btn--next');

    if (!swiperEl || !paginationEl || !prevEl || !nextEl) return;

    var slides = swiperEl.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return;

    if (typeof Swiper === 'undefined') {
      setTimeout(function () {
        initRoot(root);
      }, 100);
      return;
    }

    var loop = slides.length > 1;
    var autoplay =
      root.getAttribute('data-autoplay') === 'true' && loop
        ? { delay: parseDelaySeconds(root.getAttribute('data-autoplay-delay')), disableOnInteraction: false }
        : false;

    root._fitMonthSlideshowSwiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 500,
      loop: loop,
      autoplay: autoplay,
      watchOverflow: true,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
      on: {

        slideChangeTransitionEnd: function () {
          console.log('this', this);
          const icon_location = this.previousIndex > this.activeIndex ? 'Left' : 'Right';
          window.dataLayer.push({ event_parameters: null });
          window.dataLayer.push({
            event: 'ga4Event',
            event_name: 'image_switch',
            event_parameters: {
              icon_location: icon_location,
              position: this.realIndex + 1,
              // toFixed
              module: 'section_hyrox',
            },
          });
        },
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-fit-month-slideshow]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var target = ev.target;
    if (!target || !target.querySelector) return;
    var root = target.querySelector('[data-fit-month-slideshow]');
    if (root) initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var target = ev.target;
    if (!target || !target.querySelector) return;
    var root = target.querySelector('[data-fit-month-slideshow]');
    if (root) destroyRoot(root);
  });
})();
